import { useTranslation } from "react-i18next";
import IPartner from "../../../models/partner/IPartner";
import { Button, Card, CardFooter, CardHeader, CardPreview, Image, Link, makeStyles, Text, Title2 } from "@fluentui/react-components";
import { Open16Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
    partner: {
        maxWidth: "350px",
        "transition": "transform 0.2s",

        "&:hover": {
            transform: "translateY(-4px)"
        },

        "@media (max-width: 768px)": {
            maxWidth: "100%",
        }
    },
    partnerLogo: {
        padding: "16px",
        margin: "auto !important",

        "& img": {
            margin: "auto",
            width: "100%",
            height: "auto",
        }
    },
    header: {
        marginTop: "auto"
    },
    partnerWebsite: {
        marginTop: "8px"
    }
});

export default function PartnerCard(props: { partner: IPartner }) {
    const { t } = useTranslation("partners");
    const { partner } = props;
    const styles = useStyles();

    const title = <Title2>{partner.name}</Title2>,
        description = <Text><span dangerouslySetInnerHTML={{ __html: partner.description }} /></Text>;

    return (
        <Card className={styles.partner}>
            <CardPreview className={styles.partnerLogo}>
                <Image src={partner.image.url} alt={`${partner.image.altText}`} />
            </CardPreview>
            <CardHeader header={title} description={description} className={styles.header} />
            <CardFooter className={styles.partnerWebsite}>
                <Link as="a" href={partner.url} target="_blank">
                    <Button appearance="primary" icon={<Open16Regular />}>
                        {t("visitWebsite")}
                    </Button>
                </Link>
            </CardFooter>
        </Card>
    );
}